import React, { useEffect, useState } from 'react'
import MultiSelectFilter from '../../components/MultiSelectFilter';
import { ArrowUpOnSquareIcon, FunnelIcon } from '@heroicons/react/20/solid';
import { milestones, performanceData } from '../../components/StudentDasbordData';
import ClassPerformanceChart from '../../components/ClassPerformanceChart';
import UsageStatistics from '../../components/UsageStatistics';
import MilestoneCompletion from '../../components/MilestoneCompletion';
import TopEngagementbyStudentGrade from '../../components/TopEngagementbyStudentGrade';
import educatorimage from '../../Assests/images/educator_image.jpg'
import ProgressandAnalyticsTable from '../../components/ProgressandAnalyticsTable';
import ExportReportsOffcanvas from "../../components/ExportReportsOffcanvas";
import Filters from '../../components/MultiSelectFilter';
import { applicationService } from '../../services/applicationService';

export default function AdminProgressAndAnalytics({ permission }) {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [allGradeList, setAllGradeList] = useState([])
  const [allApplicationListFilter, setAllApplicationListFilter] = useState([])
  const [selectedFilters, setSelectedFilters] = useState({
    grades: [],
    demographics: [],
    apps: [],
  });
  const [selectedFiltersIds, setSelectedFiltersIds] = useState({
    grades: "",
    demographics: "",
    apps: "",
  });
  const filterConfigs = [
    { key: "grades", label: "All Graes", options: allGradeList, color: "blue" },
    { key: "demographics", label: "Demographics", options: allGradeList, color: "green" },
    { key: "apps", label: "All Applications", options: allApplicationListFilter, color: "orange" },
  ];

  const [studentData, setStudentData] = useState([
    {
      studentImage: educatorimage,
      studentName: "Michel Shen",
      studentId: "USR001",
      application: "MathMaster",
      grade: "6-8",
      avgScore: "86%",
      usagehours: "120",
      completion: "92%",
      trend: "Up",
    },
    {
      studentImage: educatorimage,
      studentName: "Michel Shen",
      studentId: "USR002",
      application: "MathMaster",
      grade: "6-8",
      avgScore: "86%",
      usagehours: "120",
      completion: "92%",
      trend: "Down",
    },
    {
      studentImage: educatorimage,
      studentName: "Michel Shen",
      studentId: "USR003",
      application: "MathMaster",
      grade: "6-8",
      avgScore: "86%",
      usagehours: "120",
      completion: "92%",
      trend: "Up",
    },
  ]);

  const applicationUsageBarGraph = [
    { name: "Math Quest", usageHours: 60 },
    { name: "Science Explorer", usageHours: 45 },
    { name: "Reading Adventure", usageHours: 30 },
    { name: "Art Studio", usageHours: 21 },
    { name: "Art", usageHours: 21 },
  ];

  const gradeData = [
    {
      grade: 'A',
      data: [
        { name: 'Homework', value: 400 },
        { name: 'Projects', value: 300 },
        { name: 'Participation', value: 300 },
        { name: 'Tests', value: 200 },
      ],
    },
    {
      grade: 'B',
      data: [
        { name: 'Homework', value: 300 },
        { name: 'Projects', value: 200 },
        { name: 'Participation', value: 100 },
        { name: 'Tests', value: 400 },
      ],
    },
    {
      grade: 'C',
      data: [
        { name: 'Homework', value: 200 },
        { name: 'Projects', value: 400 },
        { name: 'Participation', value: 300 },
        { name: 'Tests', value: 100 },
      ],
    },
    {
      grade: 'D',
      data: [
        { name: 'Homework', value: 100 },
        { name: 'Projects', value: 200 },
        { name: 'Participation', value: 300 },
        { name: 'Tests', value: 400 },
      ],
    },
  ];

  useEffect(() => {
    getAllGradesList()
    getAllApplicationForFilter()
  }, [])


  const getAllGradesList = async () => {
    try {
      const response = await applicationService.getAllGrades()
      if (response?.success == true) {
        setAllGradeList(response?.data)
      } else {
        setAllGradeList([])
      }
    } catch (error) {
      console.error('Error fetching data:', e)
    }
  }

  async function getAllApplicationForFilter() {
    try {
      const response = await applicationService.getAllApplicationForFilter()
      if (response?.success == true) {
        setAllApplicationListFilter(response?.data)
      } else {
        setAllApplicationListFilter([])
      }
    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }


  return (
    <div>
      <div className='flex items-center justify-between  p-4'>
        <div>
          {/* <MultiSelectFilter /> */}
          <Filters filterConfigs={filterConfigs} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} selectedFiltersIds={selectedFiltersIds} setSelectedFiltersIds={setSelectedFiltersIds} />
        </div>
        <div className='flex gap-2'>
          {/* <button className="bg-[#71757633] text-[#717576] px-3 flex gap-2 py-2 rounded-lg hover:bg-brandBlue-600 transition">
            <FunnelIcon className='w-5 h-5 text-[#717576] mt-[2px]' /> Filter  </button> */}
          {permission?.export === true &&
            <button onClick={() => setIsExportModalOpen(true)} className="bg-brandBlue text-white px-3 flex gap-2 py-2 rounded-lg hover:bg-brandBlue-600 transition">
              <span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3ZM12 16C11.2044 16 10.4413 15.6839 9.87868 15.1213C9.31607 14.5587 9 13.7956 9 13H4V5H20V13H15C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16ZM16 11H13V14H11V11H8L12 6.5L16 11Z" fill="white" />
              </svg>
              </span> Export  
              </button>
          }
        </div>
      </div>
      <div className='p-4 flex gap-2'>
        <div>
          <select className='bg-white px-3 py-2 rounded-[10px] text-[#717576] text-[16px] focus:outline-none'>
            <option>Last 30 Days</option>
          </select>
        </div>
        <div className='content-center'>
          <p className='text-[#717576] text-[15px]'>Monitor learning performance, engagement, and usage trends across all schools, grades, demographics, and applications.</p>
        </div>
      </div>
      <div className='px-4'>
        <div className="bg-white shadow rounded-2xl p-5 overflow-x-auto">
          <div className="grid md:grid-cols-2">
            <div className='p-4'>

              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-[#717576] ">
                  Performance Overview
                </h2>
              </div>
              <ClassPerformanceChart data={performanceData} />
            </div>
            <div className='p-4'>
              <h2 className="text-lg font-semibold text-[#717576] mb-4">Usage Statistics</h2>
              <UsageStatistics applicationUsageBarGraph={applicationUsageBarGraph} />
            </div>
          </div>

          <div className="grid md:grid-cols-3">
            <div className='p-4'>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-[#717576] ">
                  Performance vs Goal
                </h2>
              </div>
              <MilestoneCompletion milestones={milestones} />
            </div>
            <div className='p-4'>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-[#717576] ">
                  Top Engagement by student Grade
                </h2>
              </div>
              <TopEngagementbyStudentGrade gradeData={gradeData} />
            </div>
            <div className='p-4'>
              <h2 className="text-lg font-semibold text-[#717576] mb-4">Top Applications</h2>
              <MilestoneCompletion milestones={milestones} />
            </div>
          </div>

          <ProgressandAnalyticsTable studentData={studentData} />
        </div>
      </div>
      <ExportReportsOffcanvas
        isExportModalOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
      />
    </div>
  )
}
